<template>
  <div class="businessAdd">
    <div class="contentWrap" v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.8)">
      <div class="page-section">
        <div class="cg-main-title">下单详情</div>
        <div class="header-handle-box">
          <h3 class="state">
            当前订单状态：
            {{beCleared ? '已转为清算' : (status_pass + ' ' +status_pay)}}
          </h3>
          <div class="btns" v-show="function_orderControl">
            <button class="cg-btn red-border" v-if="!beCleared" @click="sentDealierBill">发起销售商账单</button>
            <button class="cg-btn red-border" v-if="!beCleared" @click="sentPlatformBill">发起平台账单</button>
            <button class="cg-btn red-border" v-if="beCleared" @click="toClearPage">查看清算</button>
            <button class="cg-btn red-border" v-if="!beCleared" @click="toStartClear">发起清算</button>
          </div>
          <!-- <div class="btns" v-if="!beCleared">
            <div class="handle-user">管理员操作</div>
            <button class="cg-btn red-border" @click="sentDealierBill">发起销售商账单</button>
            <button class="cg-btn red-border" @click="sentPlatformBill">发起平台账单</button>
          </div> -->
          <!-- <div class="btns" v-if="!beCleared &&　status_pass_value == 1 &&　status_pass_value == 2">
            <div class="handle-user">销售商操作</div>
            <button class="cg-btn red-border" @click="sentDealierBill">核销</button>
          </div> -->
        </div>

        <div class="order-detail-table">
          <table class="table">
            <tr class="th">
              <th width="40%">商品</th>
              <th width="20%">款号</th>
              <th width="20%">采购方</th>
              <th width="20%">下单总计</th>
            </tr>
            <tr>
              <td>
                <div class="td-1-wrap">
                  <el-image class="img" :src="imgUrl" fit="cover" :preview-src-list="srcList"></el-image>
                  <div class="title">{{orderDetail.item_name}}</div>
                </div>
              </td>
              <td>{{orderDetail.item_style_number}}</td>
              <td>{{orderDetail.dealerName}}</td>
              <td>{{orderDetail.order_purchase_quantity}}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="page-section" v-if="billList_platform.length > 0">
        <div class="cg-mod-title mgt-0">平台付款周期</div>
        <ul class="time-line">
          <li class="item" v-for="(item, index) in billList_platform" :key="index">
            <div class="item-tail"></div>
            <div class="item-node"></div>
            <div class="item-content">
              <div class="item-tit">
                <strong class="item-tit-strong">平台第{{billList_platform.length - index}}个结款周期</strong>
                <span class="item-tit-during">（周期范围：{{item.bill_start_time}} 至 {{item.bill_end_time}}）</span>
                <button class="cg-btn red-border mgl-16" v-if="!beCleared && item.order_bill_amount>0" @click="openUploadSettle(item)">上传结款凭证</button>
              </div>
              <div class="item-sum-data">
                本周期账单总金额：{{item.order_bill_amount}} 元<br>
                平台已支付总金额（被供应商确认）：{{item.order_pay_amount}} 元<br>
                平台还需支付总金额：<span class="red">{{item.rest_pay_amount}} 元</span><br>
              </div>
              <div class="item-box">
                <ul class="sub-time-line">
                  <template v-if="item.orderTransferList">
                    <li class="sub-item" v-for="(pay_ele, pay_i) in item.orderTransferList" :key="pay_i">
                      <div class="pdb-12">
                        <span class="title">
                          <span class="time">{{pay_ele.order_submit_time}}</span>
                          平台方上传了结款凭证，支付了{{pay_ele.order_payment_amount}}元
                        </span>
                        <el-tag type="success" v-if="pay_ele.order_state == 'y'">供应商已确认</el-tag>
                        <el-tag type="warning" v-if="pay_ele.order_state == 'p'">待供应商确认</el-tag>
                        <el-tag type="danger" v-if="pay_ele.order_state == 'n'">供应商已拒绝</el-tag>
                      </div>
                      <div class="pdb-12">
                        <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                          <el-image :key="img_index" v-if="img_ele" class="img" :src="img_ele" fit="cover"
                            :preview-src-list="pay_ele.imageFiles"></el-image>
                        </template>

                        <span v-if="pay_ele.order_payment_memo" class="pay-info grey">
                          说明：{{pay_ele.order_payment_memo}}
                        </span>
                      </div>
                    </li>
                  </template>
                  <li class="sub-item">
                    <div class="pdb-6">
                      <span class="time">{{item.order_submit_time}}</span>
                      系统依据平台规则发布了已核销且已确认销售商已付款的订单明细。
                    </div>
                    <div class="grey pdb-12">
                      本期平台应向供应商支付<span class="green">{{item.order_bill_amount}}</span>元
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="page-section" v-if="billList_dealer.length > 0">
        <div class="cg-mod-title mgt-0">销售商付款周期</div>
        <ul class="time-line">
          <li class="item" v-for="(item, index) in billList_dealer" :key="index">
            <div class="item-tail"></div>
            <div class="item-node"></div>
            <div class="item-content">
              <div class="item-tit">
                <strong class="item-tit-strong">销售商第{{billList_dealer.length - index}}个付款周期</strong>
                <span class="item-tit-during">（周期范围：{{item.bill_start_time}} 至 {{item.bill_end_time}}）</span>
              </div>
              <div class="item-sum-data">
                本周期内已核销总数：{{item.orderEstablishList[0] ? (item.orderEstablishList[item.orderEstablishList.length-1].beforeOrderQuantity - item.orderEstablishList[0].restQuantity) : 0}}件<br>
                本周期账单总金额：{{item.order_bill_amount}} 元<br>
                销售商已支付总金额（被平台确认）：{{item.order_pay_amount}} 元<br>
                销售商还需支付总金额：<span class="red">{{item.rest_pay_amount}} 元</span><br>
              </div>
              <div class="item-box">
                <ul class="sub-time-line">
                  <template v-if="item.orderPaymentList">
                    <li class="sub-item" v-for="(pay_ele, pay_i) in item.orderPaymentList" :key="pay_i">
                      <div class="pdb-12">
                        <span class="title">
                          <span class="time">{{pay_ele.order_submit_time}}</span>
                          销售商上传了付款凭证，支付了{{pay_ele.order_payment_amount}}元
                        </span>
                        <el-tag type="success" v-if="pay_ele.order_state == 'y'">平台已确认</el-tag>
                        <el-tag type="danger" v-if="pay_ele.order_state == 'n'">平台已拒绝</el-tag>
                        <el-tag type="warning" v-if="pay_ele.order_state == 'p'">待平台审核</el-tag>

                        <button class="cg-btn red-border mgl-16" v-if="!beCleared && pay_ele.order_state == 'p'" @click="getDealierPayDetial(item, pay_ele, item.orderEstablishList[0])">确认销售商付款凭证</button>
                      </div>
                      <div class="pdb-12">
                        <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                          <el-image :key="img_index" v-if="img_ele" class="img" :src="img_ele" fit="cover"
                            :preview-src-list="pay_ele.imageFiles"></el-image>
                        </template>

                        <span v-if="pay_ele.order_payment_memo" class="pay-info grey">
                          说明：{{pay_ele.order_payment_memo}}
                        </span>
                      </div>
                    </li>
                  </template>

                  <li class="sub-item">
                    <div class="pdb-6">
                      <span class="time">{{item.order_submit_time}}</span>
                      系统依据平台规则向销售商发布了付款账单
                    </div>
                    <div class="grey pdb-12">
                      销售商本次付款周期期间明细账单：<br>
                      本周期内已核销总数：{{item.orderEstablishList[0] ? (item.orderEstablishList[item.orderEstablishList.length-1].beforeOrderQuantity - item.orderEstablishList[0].restQuantity) : 0}}件
                      <br>
                      <template v-if="item.orderEstablishList[0]">
                        剩余未核销数：{{item.orderEstablishList[0].restQuantity}} 件 <br>
                      </template>
                      销售商需支付金额：<span class="green">{{item.order_bill_amount}} 元</span>
                    </div>
                  </li>
                  <li class="sub-item" v-for="(check_ele, check_i) in item.orderEstablishList" :key="check_i + 1000">
                    <div class="pdb-6">
                      <span class="time">{{check_ele.order_submit_time}}</span>
                      销售商第{{item.orderEstablishList.length - check_i}}次核销
                    </div>
                    <div class="grey pdb-12">
                      <!-- 核销时间：{{check_ele.order_submit_time}} <br> -->
                      核销前未核销总数 {{check_ele.beforeOrderQuantity}} 件，核销 {{check_ele.orderEstablishQuantity}} 件，剩余未核销
                      {{check_ele.restQuantity}} 件。<br>
                      核销应付款：{{check_ele.orderEstablishQuantity}}(件)x{{check_ele.unitPrice}}(元/件)x{{check_ele.supplierRate}}(%)=
                      <span class="green">{{check_ele.sumMoney}} 元</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="page-section" v-if="billList_apply.length > 0">
        <div class="cg-mod-title mgt-0">平台向销售商打款账单</div>
        <ul class="time-line">
          <li class="item" v-for="(item, index) in billList_apply" :key="index">
            <div class="item-tail"></div>
            <div class="item-node"></div>
            <div class="item-content">
              <div class="item-tit">
                <strong class="item-tit-strong">平台向销售商打款，第{{billList_apply.length - index}}个账单</strong>
                <span class="item-tit-during">（审核通过账单生成时间：{{item.order_submit_time}}）</span>
                <button class="cg-btn red-border mgl-16" v-if="!beCleared && item.remainAmount>0" @click="openPayApply(item)">上传给销售商打款凭证</button>
              </div>
              <div class="item-sum-data">
                <div >本次销售商申请总金额：{{item.order_bill_amount}} 元</div>
                <div v-if="item.amountToBeConfirmed>0">平台已支付未被确认金额：（等待销售商确认）：{{item.amountToBeConfirmed}}  元</div>
                <div v-if="item.remainAmount>0">平台还需支付总金额：<span class="red">{{item.remainAmount}} 元</span></div>
              </div>
              <div class="item-box">
                <ul class="sub-time-line">
                  <template v-if="item.orderPaymentList">
                    <li class="sub-item" v-for="(child, pay_i) in item.orderPaymentList" :key="pay_i">
                      <div class="pdb-12">
                        <span class="title">
                          <span class="time">{{child.order_submit_time}}</span>
                          平台上传了付款凭证，支付了{{child.order_payment_amount}}元
                        </span>
                        <el-tag type="success" v-if="child.order_state == 'y'">销售商已确认收到</el-tag>
                        <el-tag type="danger" v-if="child.order_state == 'n'">销售商已驳回</el-tag>
                        <el-tag type="warning" v-if="child.order_state == 'p'">待销售商确认</el-tag>
                      </div>
                      <div class="pdb-12">
                       <template v-for="(img_ele, img_index) in child.imageFiles">
                          <el-image :key="img_index" v-if="img_ele" class="img" :src="img_ele" fit="cover"
                            :preview-src-list="child.imageFiles"></el-image>
                        </template>

                        <span v-if="child.order_payment_memo" class="pay-info grey">
                          说明：{{child.order_payment_memo}}
                        </span>
                      </div>
                    </li>
                  </template>

                  <!-- <li class="sub-item">
                    <div class="pdb-6">
                      <span class="time">{{item.order_submit_time}}</span>
                      系统依据平台规则向销售商发布了付款账单
                    </div>
                    <div class="grey pdb-12">
                      销售商本次付款周期期间明细账单：<br>
                      本周期内已核销总数：件
                      <br>
                      <template >
                        剩余未核销数： 件 <br>
                      </template>
                      销售商需支付金额：<span class="green">{{item.order_bill_amount}} 元</span>
                    </div>
                  </li>
                  <li class="sub-item">
                    <div class="pdb-6">
                      <span class="time">tine</span>
                      销售商第1次核销
                    </div>
                    <div class="grey pdb-12">
                      核销前未核销总数666 件，核销 666 件，剩余未核销
                     666件。<br>
                      核销应付款：666
                      <span class="green">666元</span>
                    </div>
                  </li> -->
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="page-section" v-if="applyLists.length > 0">
        <div class="cg-mod-title mgt-0">申请记录</div>
        <ul class="time-line">
          <li class="item" v-for="(item, index) in applyLists" :key="index">
            <div class="item-tail"></div>
            <div class="item-node"></div>
            <div class="item-content">
              <div class="item-tit">
                销售商第{{applyLists.length - index}}次申请 ({{item.request_submit_time}})
              </div>
              <div class="item-box">
                <div class="grey">
                  <div style="display: inline-block;width: 200px;">申请金额：{{item.request_amount}} 元</div>
                  <el-tag type="success" v-if="item.request_state == 'y'">平台已同意</el-tag>

                  <el-tag type="info" v-if="item.request_state == 'n'">平台已驳回</el-tag>
                  <span v-if="item.request_state == 'n'&&item.request_last_update_memo">(驳回理由：{{item.request_last_update_memo}})</span>
                  <el-tag type="danger" v-if="item.request_state == 'p'">待平台审核</el-tag>
                  <button class="cg-btn red-border mgl-16" v-if="item.request_state == 'p'" @click="openApplyAuth(item)">去审核</button>
                  <br>
                  申请备注：{{item.request_content}} <br>
                  <template v-for="(img_ele, img_index) in item.imgArr">
                    <el-image :key="img_index" v-if="img_ele" class="img" :src="img_ele" fit="cover" :preview-src-list="item.imgArr"></el-image>
                  </template>



                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="page-section" v-if="checkSaleHistory.length > 0">
        <div class="cg-mod-title mgt-0">核销记录</div>
        <ul class="time-line">
          <li class="item" v-for="(item, index) in checkSaleHistory" :key="index">
            <div class="item-tail"></div>
            <div class="item-node"></div>
            <div class="item-content">
              <div class="item-tit">销售商第{{checkSaleHistory.length - index}}次核销</div>
              <div class="item-box">
                <div class="grey">
                  核销时间：{{item.order_submit_time}}
                  <br />
                  核销前未核销总数 {{item.beforeOrderQuantity}} 件，核销 {{item.orderEstablishQuantity}} 件，剩余未核销
                  {{item.restQuantity}} 件。
                  <br />
                  核销应付款：{{item.orderEstablishQuantity}}(件)x{{item.unitPrice}}(元/件)x{{item.supplierRate}}(%)=
                  <span class="green">{{item.sumMoney}} 元</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="page-section">
        <div class="cg-mod-title mgt-0">下单订单明细</div>
        <div class="basic-info mgt-24">
          <el-row>
            <el-col :span="8">
              <div class="line">
                <span class="lab">下单订单号：</span>
                <span class="val">{{orderDetail.order_number}}</span>
              </div>
            </el-col>
            <el-col :span="16">
              <div class="line">
                <span class="lab">下单时间：</span>
                <span class="val">{{orderDetail.order_submit_time}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="line blue">
                <span class="lab">下单时价格：</span>
                <span class="val">{{orderDetail.item_order_price}}元/件</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="line blue">
                <span class="lab">订单总计：</span>
                <span class="val">{{orderDetail.order_purchase_quantity}}件</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="line blue">
                <span class="lab">订单总价：</span>
                <span class="val">{{orderDetail.order_purchase_amount}}元</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="take-order-table">
          <table class="table">
            <thead>
              <tr class="th">
                <th width="15%">颜色</th>
                <th width="25%">尺码</th>
                <th width="25%">下单数量</th>
                <th width>小计</th>
              </tr>
            </thead>
            <tbody v-for="(p_item, p_index) in orderSizeColorArr" :key="p_index">
              <tr v-for="(s_item, s_index) in p_item.sizeArr" :key="s_index">
                <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.color}}</td>
                <td>{{s_item.name}}</td>
                <td>{{s_item.number}}</td>
                <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.colorChoseTotal}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="page-section" v-if="historyLockOrderList.length > 0">
        <div class="cg-mod-title mgt-0">锁仓订单明细</div>
        <div v-for="(item, index) in historyLockOrderList" :key="index">
          <div class="basic-info mgt-24">
            <el-row>
              <el-col :span="8">
                <div class="line">
                  <span class="lab">锁仓订单号：</span>
                  <span class="val">{{item.order_number}}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="line">
                  <span class="lab">发起锁仓时间：</span>
                  <span class="val">{{item.reserve_order_submit_time}}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="line">
                  <span class="lab">同意锁仓时间：</span>
                  <span class="val">{{item.reserve_order_last_update_time}}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="line blue">
                  <span class="lab">下单时价格：</span>
                  <span class="val">{{item.item_order_price}}元/件</span>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="take-order-table mgt-24">
            <table class="table">
              <thead>
                <tr class="th">
                  <th width="20%">颜色</th>
                  <th width="20%">尺码</th>
                  <th width="30%">锁仓数</th>
                  <th width>锁仓小计</th>
                </tr>
              </thead>
              <tbody v-for="(p_item, p_index) in item.group" :key="p_index">
                <tr v-for="(s_item, s_index) in p_item.sizeArr" :key="s_index">
                  <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.color}}</td>
                  <td>{{s_item.name}}</td>
                  <td>{{s_item.sizelockNumber}}</td>
                  <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.colorChoseTotal}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="gap-line"></div>
        </div>
      </div>
      <!-- 确认销售商付款凭证 -->
      <el-dialog title="确认销售商付款凭证" :visible.sync="adminSureDealerPayPop" width="800px" :close-on-click-modal="false">
        <div class="cg-dialog-body">
          <div class="line">下单订单号：<span class="black">{{orderDetail.order_number}}</span></div>
          <div class="line pdb-20">商品款号：<span class="black">{{orderDetail.item_style_number}}</span></div>

          <div class="line pdb-20">本次付款周期期间明细账单：</div>
          <div class="line">已核销总数：<span class="black">{{dealerCheckDetail.restQuantity == undefined ? '--' : orderDetail.order_purchase_quantity - dealerCheckDetail.restQuantity}}件</span></div>
          <div class="line">剩余未核销数：<span class="black">{{dealerCheckDetail.restQuantity == undefined ? '--' : dealerCheckDetail.restQuantity}}件</span></div>
          <div class="line pdb-20">销售需支付金额：<span class="black">{{dealerPopShowData.sumAmount}}元</span></div>

          <div class="line">本期账单累计已支付：<span class="black">{{dealerPopShowData.hadPaidAmount}}元</span></div>
          <div class="line pdb-20">本期需支付金额：<span class="red">{{dealerPopShowData.restPayAmount}}元</span></div>

          <div class="line">本次销售商付款金额：<span class="black">{{dealerPopShowData.currentPay}}元</span></div>
          <div class="line">剩余欠款金额：<span class="red">{{dealerPopShowData.debt}}元</span></div>
        </div>
        <div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="danger" @click="adminRejectDealerPay">未收到{{dealerPopShowData.currentPay}}元，驳回要求重新提交</el-button>
          <el-button type="primary" @click="adminSureDealerPay">确认收到{{dealerPopShowData.currentPay}}元</el-button>
        </div>
      </el-dialog>

      <!-- 平台上传结款凭证 -->
      <el-dialog title="上传结款凭证" :visible.sync="uploadsettlePayPop" width="800px" :close-on-click-modal="false">
        <div class="cg-dialog-body">
          <div class="line">下单订单号：<span class="black">{{orderDetail.order_number}}</span></div>
          <div class="line pdb-20">商品款号：<span class="black">{{orderDetail.item_style_number}}</span></div>

          <div class="line pdb-20">本次付款周期期间明细账单：</div>
          <!-- <div class="line">已核销总数：<span class="black"> ? (件)+ ? (件) =  ? 件</span></div>
              <div class="line">剩余未核销数：<span class="black"> ? - ? - ? = ? 件</span></div>
              <div class="line pdb-20">销售需支付金额：<span class="black"> ? 元+ ? 元= ? 元</span></div> -->
          <div class="line">本期账单总金额：<span class="black">{{platformPopShowData.sumAmount}}元</span></div>
          <div class="line">本期账单累计已支付：<span class="black">{{platformPopShowData.hadPaidAmount}}元（供应商已确认的支付金额）</span></div>
          <div class="line pdb-20">本期还需支付金额：<span class="red">{{platformPopShowData.restPayAmount}}元</span>（本周期总金额 -
            供应商已确认的支付金额）</div>

          <el-form ref="ruleForm" label-width="160px" :model="uploadsettleForm" :rules="uploadsettlerules">
            <el-form-item label="本次实际付款金额：" prop="amount">
              <el-input placeholder="请输入付款金额" style="width: 300px" :value="uploadsettleForm.amount" @input="inputPriceHandle"
                @blur="blurPriceHandle"></el-input>
            </el-form-item>
            <el-form-item label="上传结款凭证：">
              <div>
                <el-upload :action="uploadFileApi" name="files" list-type="picture-card" :file-list="uploadsettleImgsList"
                  :multiple="false" :data="uploadData" :on-remove="handleRemove" :before-upload="beforeUpload"
                  :on-success="onSuccess" :on-error="onError" accept="image/*">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="付款说明：">
              <el-input type="textarea" placeholder="请输入说明，最多300个字" v-model="uploadsettleForm.memo"></el-input>
            </el-form-item>
          </el-form>

        </div>
        <div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="uploadsettlePayPop = false">取 消</el-button>
          <el-button type="primary" @click="uploadsettleSubmit">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 发起清算 -->
      <el-dialog title="发起清算" :visible.sync="clearSurePop" width="800px" center>
        <div class="clear-sure-top">
          <el-image class="img" :src="imgUrl" fit="cover">
          </el-image>
          <div class="info">
            <span>名称：{{orderDetail.item_name}}</span> <br>
            <span>款号：{{orderDetail.item_style_number}}</span>
          </div>
          <div class="count">共查询到{{clearOrderList.length}}条数据</div>
        </div>
        <el-table :data="clearOrderList" size="small">
          <el-table-column prop="order_number" label="下单订单号" width="160"></el-table-column>
          <el-table-column prop="item_order_price" label="价格(元)">
            <template slot-scope="scope">
              {{scope.row.item_order_price}}
            </template>
          </el-table-column>
          <el-table-column prop="order_purchase_quantity" label="下单数">
          </el-table-column>
          <el-table-column prop="paidAmount" label="已确认付款(元)">
            <template slot-scope="scope">
              /
            </template>
          </el-table-column>
          <el-table-column prop="unpaidAmount" label="欠款(元)">
            <template slot-scope="scope">
              /
            </template>
          </el-table-column>
        </el-table>

        <div slot="footer" class="dialog-footer">
          <el-button @click="clearSurePop = false">取 消</el-button>
          <el-button type="primary" @click="checkPaymentStatus">确认清算</el-button>
        </div>
      </el-dialog>
      <applyAuth v-show="isShowApplyAuthModal" :info="currentApplyAuthObj" @close="closeApplyAuthModal" @success="closeApplyAuthModalAndSuccess">  </applyAuth>
      <applypay v-show="isShowPayApplyModal" :info="currentPayApplyObj" @close="closeApplyPayModal" @success="closeApplyPayModalAndSuccess">  </applypay>

    </div>
  </div>
</template>

<script>
  import {
    json,
    wordData,
    utils
  } from "@/common/common.js";
  import {
    ajaxPost,
    api
  } from "@/common/request.js";
  import {
    accMul,
    validatePrice
  } from "@/common/tool.js";
  import applyAuth from "@/components/applyAuth";
  import applypay from "@/components/paymodal_apply.vue";

  export default {
    data() {
      var validatePriceFn = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入金额'))
        } else if (!validatePrice(value)) {
          callback(new Error('金额格式不正确'))
        } else {
          callback();
        }
      }
      return {
        isLoading: false,
        beCleared: false, // 是否已转为清算
        status_pass: '', // 核销状态描述
        status_pass_value: '', // 核销状态值 1 - 未核销 2 - 部分核销 3 - 全部核销
        status_pay: '', // 付款状态描述
        status_pay_value: '', // 付款状态值  1 - 未确认付款  2 - 部分付款确认  3 - 全部确认
        // 下单订单详情
        orderDetail: {
          dealer_user_id: "",
          item_id: "",
          item_main_image_id: "",
          item_name: "",
          item_order_price: "",
          item_style_number: "",
          item_thumbnail_image_id: "",
          order_content: "",
          order_id: "",
          order_number: "",
          order_purchase_amount: "",
          order_purchase_quantity: "",
          order_state: "",
          order_submit_time: "",
          order_user_address_id: "",
          parent_order_id: "",
          productMainImageFile: "",
          supplier_user_id: "",
          sumEstablishQuantity: "",
          itemFeeSplitting: "",
          supplier_rate: "",
          dealer_rate: "",
          addressInfo: {
            address_contact_name: "",
            address_contact_phone: "",
            address_string: "",
            region_district_string: "",
            region_city_string: "",
            region_province_string: ""
          }
        },
        // 详情图片
        imgUrl: "",
        srcList: [],

        // 锁仓尺码数据
        lockSizeColorArr: [],

        // 下单尺码数据
        orderSizeColorArr: [],

        // 历史锁单列表
        historyLockOrderList: [],

        // 核销记录
        checkSaleHistory: [],

        // 账单列表
        billList_dealer: [],
        billList_platform: [],

        // 确认销售商付款凭证 弹框
        adminSureDealerPayPop: false,
        dealerPeriodPayDetail: {},
        dealerSinglePayDetail: {},
        dealerCheckDetail: {}, // 核销数据
        dealerPopShowData: {}, // 弹框金额展示


        // 上传结款凭证 弹框
        uploadsettlePayPop: false,
        uploadFileApi: api.baseUrl + '/file/uploadfilebatch',
        uploadData: {
          imageType: 12301,
          imageUserId: ''
        },
        currentPlatformBill: {},
        platformPopShowData: {},
        uploadsettleImgsList: [],
        uploadsettleForm: {
          amount: '',
          memo: ''
        },
        uploadsettlerules: {
          amount: [{
              required: true,
              message: '请输入金额',
              trigger: 'blur'
            },
            {
              validator: validatePriceFn,
              trigger: 'blur'
            }
          ],
        },

        // 清算确认弹框
        clearSurePop: false,
        clearOrderList: [],

        applyLists: [],
        isShowApplyAuthModal: false,
        currentApplyAuthObj: {},

        billList_apply: [],
        isShowPayApplyModal:false,
        currentPayApplyObj:{}
      };
    },
    computed: {
      IMG_PREV() {
        return api.imgPrev;
      },
      adminId() {
        return utils.getAdminId()
      },
      function_lockView() {
        return utils.getCurrentFunction().indexOf("lockView")>-1
      },
      function_lockControl() {
        return utils.getCurrentFunction().indexOf("lockControl")>-1
      },
      function_orderView() {
        return utils.getCurrentFunction().indexOf("orderView")>-1
      },
      function_orderControl() {
        return utils.getCurrentFunction().indexOf("orderControl")>-1
      },
      function_clearView() {
        return utils.getCurrentFunction().indexOf("clearView")>-1
      },
      function_clearControl() {
        return utils.getCurrentFunction().indexOf("clearControl")>-1
      },
    },
    components: {
      applyAuth,applypay
    },
    created() {
      this.uploadData.imageUserId = this.adminId
      this.getReserverOrderInfo();
    },
    methods: {
      openPayApply(list){
        console.log(list)
        this.isShowPayApplyModal=true
        // this.currentPayApplyObj=list
        this.currentPayApplyObj={
          purchaseOrderId:list.parent_order_id,
          supplierUserId: list.supplier_user_id,
          dealerUserId: list.dealer_user_id,
          itemId: list.ces,
          billOrderId:list.order_id,
          maxNumber:list.remainAmount
        }
      },
      closeApplyPayModal() {
        this.isShowPayApplyModal = false
      },
      closeApplyPayModalAndSuccess() {
        this.isShowPayApplyModal = false
        this.getReserverOrderInfo();
      },
      openApplyAuth(list) {
        console.log(list)
        this.isShowApplyAuthModal = true
        this.currentApplyAuthObj = list
      },
      closeApplyAuthModal() {
        this.isShowApplyAuthModal = false
      },
      closeApplyAuthModalAndSuccess() {
        this.isShowApplyAuthModal = false
        this.getReserverOrderInfo();
      },
      getApplyList() {
        let _this = this
        this.applyLists = []
        ajaxPost("dwOrder/applicationList", {
          orderPurchaseNumber: this.$route.query.orderNumber
        }).then(res => {
          if (res.errorCode == 200) {
            this.applyLists = res.data.map(function(item, index) {
              console.log(item)
              item.imgArr = item.image_file ? item.image_file.split(',').map(ele => ele ? _this.IMG_PREV + ele :
                '') : []
              return item
            })

          } else {
            this.$message.error(res.errorMsg)
          }
        })
      },
      // 上传图片
      beforeUpload(file) {
        console.log('beforeUpload', file)
        if (!(file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png')) {
          this.$message({
            type: 'warning',
            message: '必须为图片且要求是.png或.jpg格式!'
          })
          return false
        } else if (file.size > 10 * 1024 * 1024) {
          this.$message({
            type: 'warning',
            message: '图片大小不能超过10M!'
          })
          return false
        }
      },
      onSuccess(response, file, fileList) {
        console.log('onSuccess', response, file, fileList)
        this.uploadsettleImgsList = fileList
      },
      onError(err, file, fileList) {
        console.log('onError', err, file, fileList)
        this.$message({
          type: 'error',
          message: '图片上传失败!'
        })
      },
      // 图片删除
      handleRemove(file, fileList) {
        console.log(file, fileList)
        this.uploadsettleImgsList = fileList
      },

      // 平台上传结算凭证
      openUploadSettle(item) {
        this.currentPlatformBill = item
        this.platformPopShowData = {
          sumAmount: (+item.order_bill_amount).toFixed(2),
          hadPaidAmount: (+item.order_pay_amount).toFixed(2),
          restPayAmount: (item.order_bill_amount - item.order_pay_amount).toFixed(2)
        }

        this.uploadsettleImgsList = [];
        this.uploadsettleForm.amount = '';
        this.uploadsettleForm.memo = '';

        this.uploadsettlePayPop = true
      },

      inputPriceHandle(e) {
        const reg = /((^\s{0}|^\d*))(\.\d*){0,1}$/
        if (reg.test(e)) {
          this.uploadsettleForm.amount = e
        }
      },
      blurPriceHandle() {
        if (this.uploadsettleForm.amount != '') {
          let val = parseFloat(this.uploadsettleForm.amount);
          this.uploadsettleForm.amount = val.toFixed(2);
        }
      },

      // 上传结款凭证
      uploadsettleSubmit() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            console.log('this.uploadsettleForm', this.uploadsettleForm)
            console.log('this.uploadsettleImgsList', this.uploadsettleImgsList)
            let ImgsList = this.uploadsettleImgsList.map(item => {
              return {
                imageFiles: item.response.data.imageFiles,
                imgId: item.response.data.imgId
              }
            })
            let ImgsListStr = JSON.stringify(ImgsList)
            ajaxPost("/dwOrder/saveTransferPayment", {
              "supplierUserId": this.orderDetail.supplier_user_id,
              "dealerUserId": this.orderDetail.dealer_user_id,
              "orderPurchaseNumber": this.orderDetail.order_number,
              "itemId": this.orderDetail.item_id,
              "imgJson": ImgsListStr,
              "transferBillOrderId": this.currentPlatformBill.order_id,
              "orderTransferAmount": this.uploadsettleForm.amount,
              "orderTransferMemo": this.uploadsettleForm.memo,
              "adminId": this.adminId
            }).then(res => {
              console.log(res)
              if (res.errorCode == 200) {
                this.uploadsettlePayPop = false
                this.$message.success(res.errorMsg || '操作成功')
                this.getBillList(1)
                this.getBillList(2)
              } else {
                this.$message.error(res.errorMsg || '操作失败')
              }
            }).catch(err => {
              console.log(err)
            })
          }
        })
      },
      // 获取订单数据
      getReserverOrderInfo() {
        this.isLoading = true;
        ajaxPost("/dwOrder/getOrderPurchaseInfo", {
            orderPurchaseNumber: this.$route.query.orderNumber
          })
          .then(res => {
            this.isLoading = false;
            if (res.errorCode == 200) {
              let detail = res.data[0];
              this.orderDetail = detail;
              this.imgUrl = this.IMG_PREV + detail.productMainImageFile;
              this.srcList.push(this.imgUrl);

              this.orderDetail.supplier_rate = this.orderDetail.itemFeeSplitting ?
                accMul(this.orderDetail.itemFeeSplitting.split(",")[1], 100) :
                "";
              this.orderDetail.dealer_rate = this.orderDetail.itemFeeSplitting ?
                accMul(this.orderDetail.itemFeeSplitting.split(",")[0], 100) :
                "";

              if (this.orderDetail.liquidateState && this.orderDetail.liquidateState == '4') {
                this.beCleared = true
              } else {
                this.beCleared = false
              }

              if (!this.orderDetail.sumEstablishQuantity) {
                this.status_pass = '从未核销'
                this.status_pass_value = 1
              } else if (this.orderDetail.sumEstablishQuantity < this.orderDetail.order_purchase_quantity) {
                this.status_pass = '部分核销'
                this.status_pass_value = 2
              } else if (this.orderDetail.sumEstablishQuantity == this.orderDetail.order_purchase_quantity) {
                this.status_pass = '全部核销'
                this.status_pass_value = 3
              }

              if (!this.orderDetail.paidAmount) {
                this.status_pay = '从未付款'
                this.status_pay_value = 1
              } else if (this.orderDetail.unpaidAmount > 0) {
                this.status_pay = '部分付款'
                this.status_pay_value = 2
              } else if (this.orderDetail.unpaidAmount == 0) {
                this.status_pay = '全部付款'
                this.status_pay_value = 3
              }

              try {
                let group = JSON.parse(detail.order_content);
                let arr = group.group;
                this.orderSizeColorArr = arr || [];
                console.log(this.orderSizeColorArr);
              } catch (error) {
                console.log(error);
                this.orderSizeColorArr = [];
              }

              if (
                detail.reserverOrderInfoList &&
                detail.reserverOrderInfoList.length > 0
              ) {
                this.historyLockOrderList = detail.reserverOrderInfoList.map(
                  item => {
                    let group = [];
                    try {
                      let order_content = JSON.parse(item.order_content);
                      group = order_content.group;
                    } catch (error) {
                      console.log(error);
                    }
                    return {
                      ...item,
                      group
                    };
                  }
                );
              }
              console.log(this.historyLockOrderList);

              this.getOrderEstablish(detail.order_id);
              this.getBillList(1);
              this.getBillList(2);
              this.getBillList(5);
              this.getApplyList()
            }
          })
          .catch(err => {
            this.isLoading = false;
            console.log(err);
          });
      },

      // 发起销售商账单
      sentDealierBill() {
        this.$confirm('确认发起销售商账单吗', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajaxPost("/dwOrder/sendBillInfo", {
            "orderPurchaseNumber": this.$route.query.orderNumber
          }).then(res => {
            if (res.errorCode == 200) {
              this.$message.success(res.errorMsg || '操作成功')
              this.getBillList(1)
              this.getBillList(2)
            } else {
              this.$message.error(res.errorMsg || '操作失败')
            }
          })
        })
      },

      // 发起平台账单
      sentPlatformBill() {
        this.$confirm('确认发起平台账单吗', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajaxPost("/dwOrder/sendPlatformBill", {
            "orderPurchaseNumber": this.$route.query.orderNumber
          }).then(res => {
            if (res.errorCode == 200) {
              this.$message.success(res.errorMsg || '操作成功')
              this.getBillList(1)
              this.getBillList(2)
            } else {
              this.$message.error(res.errorMsg || '操作失败')
            }
          })
        })
      },

      // 获取核销数据
      getOrderEstablish(orderId) {
        this.isLoading = true;
        ajaxPost("/dwOrder/getOrderEstablish", {
            orderId
          })
          .then(res => {
            this.isLoading = false;
            if (res.errorCode == 200) {
              let unitPrice, supplierRate, sumMoney;
              unitPrice = this.orderDetail.item_order_price;
              supplierRate = this.orderDetail.itemFeeSplitting ?
                this.orderDetail.itemFeeSplitting.split(",")[1] :
                "";

              this.checkSaleHistory = res.data.map(item => {
                let quantityObj = JSON.parse(item.order_content);
                try {
                  let s1 = accMul(unitPrice, quantityObj.orderEstablishQuantity);
                  let s2 = accMul(s1, supplierRate);
                  sumMoney = s2.toFixed(2);
                } catch (error) {
                  sumMoney = "--";
                }
                return {
                  ...item,
                  orderEstablishQuantity: quantityObj.orderEstablishQuantity,
                  beforeOrderQuantity: quantityObj.beforeOrderQuantity,
                  restQuantity: quantityObj.beforeOrderQuantity - quantityObj.orderEstablishQuantity,
                  unitPrice: unitPrice,
                  supplierRate: accMul(Number(supplierRate), 100),
                  sumMoney: sumMoney
                };
              });
            }
          })
          .catch(err => {
            _this.isLoading = false;
            console.log(err);
          });
      },

      // 获取账单信息  1 - 销售商  2 - 平台
      getBillList(type) {
        ajaxPost('/dwOrder/getBillList', {
          billType: type,
          orderPurchaseNumber: this.orderDetail.order_number,
          liquidateOrderId: this.orderDetail.parent_order_id
        }).then(res => {
          console.log(res);
          if (res.errorCode == 200) {
            if (type == 1) {
              this.billList_dealer = res.data.map(element => {
                return {
                  ...element,
                  order_bill_amount: (+element.order_bill_amount).toFixed(2),
                  order_pay_amount: (+element.order_pay_amount).toFixed(2) || 0,
                  rest_pay_amount: element.order_pay_amount ? (element.order_bill_amount - element.order_pay_amount)
                    .toFixed(2) : element.order_bill_amount.toFixed(2),
                  orderEstablishList: element.orderEstablishList ? element.orderEstablishList.map(item => {
                    let unitPrice, supplierRate, sumMoney;
                    unitPrice = this.orderDetail.item_order_price;
                    supplierRate = this.orderDetail.itemFeeSplitting ?
                      this.orderDetail.itemFeeSplitting.split(",")[1] :
                      "";
                    let quantityObj = JSON.parse(item.order_content);
                    try {
                      let s1 = accMul(unitPrice, quantityObj.orderEstablishQuantity);
                      let s2 = accMul(s1, supplierRate);
                      sumMoney = s2.toFixed(2);
                    } catch (error) {
                      sumMoney = "--";
                    }
                    return {
                      ...item,
                      orderEstablishQuantity: quantityObj.orderEstablishQuantity,
                      beforeOrderQuantity: quantityObj.beforeOrderQuantity,
                      restQuantity: quantityObj.beforeOrderQuantity -
                        quantityObj.orderEstablishQuantity,
                      unitPrice: unitPrice,
                      supplierRate: accMul(Number(supplierRate), 100),
                      sumMoney: sumMoney
                    };
                  }).reverse() : [],
                  orderPaymentList: element.orderPaymentList ? element.orderPaymentList.map(item => {
                    return {
                      ...item,
                      imageFiles: item.image_file ? item.image_file.split(',').map(ele => ele ? this.IMG_PREV +
                        ele : '') : []
                    }
                  }) : []
                }
              });

            }
            if (type == 2) {
              this.billList_platform = res.data.map(element => {
                return {
                  ...element,
                  order_bill_amount: (+element.order_bill_amount).toFixed(2),
                  order_pay_amount: (+element.order_pay_amount).toFixed(2) || 0,
                  rest_pay_amount: element.order_pay_amount ? (element.order_bill_amount - element.order_pay_amount)
                    .toFixed(2) : element.order_bill_amount.toFixed(2),
                  orderTransferList: element.orderTransferList ? element.orderTransferList.map(item => {
                    return {
                      ...item,
                      imageFiles: item.image_file ? item.image_file.split(',').map(ele => ele ? this.IMG_PREV +
                        ele : '') : []
                    }
                  }) : []
                }
              });
            }
            if (type == 5) {
              this.billList_apply = res.data.map(element => {
                return {
                  ...element,
                  orderPaymentList: element.orderPaymentList ? element.orderPaymentList.map(item => {
                    return {
                      ...item,
                      imageFiles: item.image_file ? item.image_file.split(',').map(ele => ele ? this.IMG_PREV +
                        ele : '') : []
                    }
                  }) : []
                }
              });
            }

          } else {

          }
        }).catch(err => {
          console.log(err)
        })
      },

      // 销售商付款明细
      getDealierPayDetial(item, pay_ele, check_ele) {
        this.dealerPeriodPayDetail = item;
        this.dealerSinglePayDetail = pay_ele;
        if (check_ele) {
          this.dealerCheckDetail = check_ele;
        } else {
          this.dealerCheckDetail = {}
        }

        console.log(item);
        this.dealerPopShowData = {
          sumAmount: (+item.order_bill_amount).toFixed(2),
          hadPaidAmount: (+item.order_pay_amount).toFixed(2),
          restPayAmount: (item.order_bill_amount - item.order_pay_amount).toFixed(2),
          currentPay: pay_ele.order_payment_amount.toFixed(2),
          debt: (item.order_bill_amount - item.order_pay_amount - pay_ele.order_payment_amount).toFixed(2)
        }
        this.adminSureDealerPayPop = true;
      },
      // 确认销售商付款
      adminSureDealerPay() {
        ajaxPost('/dwOrder/confirmPayment', {
          "supplierUserId": this.orderDetail.supplier_user_id,
          "dealerUserId": this.orderDetail.dealer_user_id,
          "orderPurchaseNumber": this.orderDetail.order_number,
          "billOrderId": this.dealerSinglePayDetail.bill_order_id,
          "orderPaymentNumber": this.dealerSinglePayDetail.order_number,
          "orderPaymentState": "y"
        }).then(res => {
          console.log(res);
          if (res.errorCode == 200) {
            this.adminSureDealerPayPop = false
            this.$message.success('操作成功')
            this.getBillList(1)
            this.getBillList(2)
          } else {
            this.$message.error(res.errorMsg || '操作失败')
          }
        }).catch(err => {
          console.log(err)
        })
      },
      // 拒绝 销售商付款
      adminRejectDealerPay() {
        ajaxPost('/dwOrder/confirmPayment', {
          "supplierUserId": this.orderDetail.supplier_user_id,
          "dealerUserId": this.orderDetail.dealer_user_id,
          "orderPurchaseNumber": this.orderDetail.order_number,
          "billOrderId": this.dealerSinglePayDetail.bill_order_id,
          "orderPaymentNumber": this.dealerSinglePayDetail.order_number,
          "orderPaymentState": "n"
        }).then(res => {
          console.log(res);
          if (res.errorCode == 200) {
            this.adminSureDealerPayPop = false
            this.$message.success('操作成功')
            this.getBillList(1)
            this.getBillList(2)
          } else {
            this.$message.error(res.errorMsg || '操作失败')
          }
        }).catch(err => {
          console.log(err)
        })
      },

      // 发起清算
      toStartClear(row) {
        this.clearSurePop = true
        this.getCanClearOrder()
      },
      // 获取可清算订单
      getCanClearOrder() {
        ajaxPost('/dwOrder/getOrderPurchaseList', {
          "supplierUserId": this.orderDetail.supplier_user_id,
          "dealerUserId": this.orderDetail.dealer_user_id,
          "itemId": this.orderDetail.item_id
        }).then(res => {

          console.log('getOrderPurchaseList', res)
          if (res.errorCode == 200) {
            this.clearOrderList = res.data
          } else {
            this.$message.error(res.errorMsg || '获取数据失败')
          }
        }).catch(err => {

          console.log(err)
        })
      },
      // 检查检查有没有付款没有确认的订单
      checkPaymentStatus() {
        ajaxPost('/dwOrder/checkPaymentStatus', {
            "supplierUserId": this.orderDetail.supplier_user_id,
            "dealerUserId": this.orderDetail.dealer_user_id,
            "itemId": this.orderDetail.item_id
          }).then(res => {
            console.log(res)
            if (res.errorCode == 200) {
              this.launchLiquidate()
            } else {
              this.$message.error(res.errorMsg || '网络异常')
              // -19999 还有付款信息没有确认
            }
          })
          .catch(err => {
            console.log(err);
          })
      },
      // 发起清算 api
      launchLiquidate() {
        ajaxPost('/dwOrder/launchLiquidate', {
            "supplierUserId": this.orderDetail.supplier_user_id,
            "dealerUserId": this.orderDetail.dealer_user_id,
            "itemId": this.orderDetail.item_id,
            "orderState": "2",
            // "liquidateOrderId":"",
            "orderSubmitType": "supplier"
          })
          .then(res => {
            console.log(res);
            if (res.errorCode == 200) {
              this.$message.success(res.errorMsg || "操作成功");
              this.clearSurePop = false
              this.clearOrderList = []
              this.getReserverOrderInfo();
            } else {
              this.$message.error(res.errorMsg || "操作是失败");
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      // 跳转清算页面
      toClearPage() {
        this.$router.push('/order/clearDetail?orderId=' + this.orderDetail.liquidateOrderId);
      }
    }
  };
</script>

<style scoped lang="scss">
  .page-section {
    padding: 24px 24px;
    background: #fff;
    margin-bottom: 16px;
  }

  .header-handle-box {
    min-width: 980px;
    box-sizing: border-box;
    margin-top: 24px;
    border: 1px solid #e6e6e6;
    background: #fafafa;
    padding: 20px 60px;

    .state {
      font-size: 20px;
      color: #333;
      font-weight: 500;
      line-height: 1;

      &.red {
        color: #f81d22;
      }
    }

    .btns {
      margin-top: 20px;
      margin-bottom: 10px;

      .handle-user {
        color: #666;
        font-size: 13px;
        margin-bottom: 10px;
      }

      .cg-btn {
        margin-right: 20px;
      }
    }

    .tip {
      margin-top: 14px;
      height: 20px;
      font-size: 14px;
      color: rgba(51, 51, 51, 0.6);
      line-height: 20px;
    }

    .tip-small {
      margin-left: 8px;
      height: 20px;
      font-size: 14px;
      color: rgba(51, 51, 51, 0.6);
      font-size: normal;
      line-height: 20px;
    }
  }

  .basic-info {
    &.mgt-24 {
      margin-top: 24px;
    }

    &.mgt-40 {
      margin-top: 40px;
    }

    .line {
      padding-bottom: 16px;
      font-size: 14px;
      line-height: 22px;

      .lab {
        color: rgba(0, 0, 0, 0.85);
      }

      .val {
        color: rgba(0, 0, 0, 0.65);
      }

      &.blue .lab,
      &.blue .val {
        color: #1890ff;
      }

      .green {
        color: #52c41a;
      }

      .text-btn {
        margin-left: 16px;
        background: transparent;
        border: none;
        font-size: 14px;
        color: #1890ff;
        outline: none;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .order-detail-table {
    margin-top: 24px;

    .table {
      border: 1px solid #e6e6e6;
      width: 100%;
      min-width: 980px;
      border-spacing: 0;
      border-collapse: collapse;
      font-size: 14px;

      tr.th {
        background: #fafafa;
        height: 55px;
      }

      tr th {
        color: rgba(0, 0, 0, 0.85);
        font-weight: normal;
      }

      td {
        padding: 32px 24px 0;
        color: rgba(0, 0, 0, 0.85);
        text-align: center;
        vertical-align: top;
      }

      tr:last-child td {
        padding-bottom: 32px;
      }

      .td-1-wrap {
        height: 100px;

        .img {
          border: 1px solid #f0f0f0;
          float: left;
          width: 100px;
          height: 100px;
          margin-right: 24px;
        }

        .title {
          text-align: left;
        }
      }
    }

    .rate-info {
      margin-top: 15px;
    }
  }

  .goods-size-list {
    border: 1px solid #e6e6e6;
    border-top: none;

    &.mgt-24 {
      margin-top: 24px;
    }

    .color-list {
      .color-head {
        color: rgba(0, 0, 0, 0.85);
        font-weight: normal;
        height: 50px;
        padding: 0 80px 0 48px;
        line-height: 50px;
        border-bottom: 1px solid #e6e6e6;
        border-top: 1px solid #e6e6e6;
        background: #fafafa;

        .t1 {
          float: left;
          width: 300px;
        }

        .t2 {
          float: left;
        }
      }

      .size-wrap {
        padding: 24px 24px 0 48px;
      }

      .size-list {

        th,
        td {
          width: 100px;
          padding: 0 0 24px 0;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
        }

        th {
          text-align: left;
          font-weight: normal;
        }
      }
    }
  }

  .agree-lock-tips {
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    padding-bottom: 10px;
  }

  .take-order-table {
    &.scroll {
      height: 50vh;
      overflow-y: auto;
      overflow-x: visible;
    }

    .table {
      border: 1px solid #e6e6e6;
      width: 100%;
      min-width: 980px;
      border-spacing: 0;
      border-collapse: collapse;
      font-size: 14px;

      tr {
        height: 50px;
      }

      tr.th {
        background: #fafafa;
      }

      tr th {
        color: rgba(0, 0, 0, 0.85);
        font-weight: normal;
      }

      td {
        border: 1px solid #e6e6e6;
        text-align: center;
        color: rgba(0, 0, 0, 0.85);
      }

      &.min-400 {
        min-width: 400px;
      }
    }

    &.mgt-24 {
      margin-top: 24px;
    }

    &.clearing {
      margin-top: 24px;
    }

    &.clearing tr th {
      border: 1px solid #e6e6e6;
    }

    &.clearing tr th:last-child,
    &.clearing tr td:last-child {
      color: #f81d22;
    }
  }

  .gap-line {
    margin: 40px 0;
    height: 1px;
    background: #e6e6e6;
  }

  .time-line {
    margin-top: 24px;
    list-style: none;

    .item {
      position: relative;

      .item-tail {
        position: absolute;
        top: 6px;
        left: 4px;
        width: 2px;
        height: 100%;
        background: #f7f7f7;
      }

      .item-node {
        position: absolute;
        top: 6px;
        left: 0;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #d9d9d9;
      }

      &:first-child .item-node {
        background: #2a2e3f;
      }

      &:last-child .item-tail {
        width: 0;
      }

      .item-content {
        padding-left: 32px;
        font-size: 14px;
        font-weight: 500;
        width: 800px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 24px;
        padding-bottom: 16px;
      }

      .item-tit {
        padding-bottom: 8px;

        .item-tit-strong {
          font-size: 14px;
          color: #000;
          font-weight: bold;
        }

        .item-tit-during {
          font-size: 13px;
          color: #000;
        }
      }

      .item-sum-data {
        background: rgba(5, 4, 4, 0.02);
        padding: 16px 24px;
        position: relative;

        &::after {
          content: ' ';
          height: 1px;
          border-bottom: 1px dashed #ccc;
          position: absolute;
          left: 24px;
          right: 24px;
          bottom: 0;
        }
      }

      .item-box {
        background: rgba(0, 0, 0, 0.02);
        border-radius: 2px;
        padding: 24px;

        .img {
          width: 100px;
          height: 100px;
          border: 1px solid #eee;
          vertical-align: top;
        }

        .pay-info {
          display: inline-block;
          width: 400px;
          margin-left: 10px;
          font-size: 13px;
        }

        .pdb-12 {
          padding-bottom: 12px;
        }

        .pdb-6 {
          padding-bottom: 6px;
        }

        .grey {
          color: rgba(0, 0, 0, 0.45);
        }

        .green {
          color: #52c41a;
        }

        .blue {
          color: #1890ff;
        }
      }
    }

    .sub-time-line {
      list-style: none;

      .sub-item {
        position: relative;
        padding-left: 24px;

        .title {
          display: inline-block;
          width: 450px;
        }

        .time {
          font-size: 13px;
          color: #000;
          margin-right: 6px;
        }

        &::before {
          content: " ";
          position: absolute;
          top: 15px;
          left: 3px;
          width: 1px;
          height: calc(100% - 12px);
          background: #d8d8d8;
        }

        &::after {
          content: " ";
          position: absolute;
          top: 6px;
          left: 0;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #fff;
          border: 1px solid #d8d8d8;
          box-sizing: border-box;
        }

        &:first-child::after {
          background: #ff9c6e;
          border: 1px solid #ff9c6e;
        }

        &:last-child::before {
          width: 0;
        }
      }
    }
  }

  .address-wrap {
    padding-top: 16px;
  }

  .address-label {
    font-size: 14px;
    font-weight: 500;
    color: #666;
    line-height: 30px;
  }

  .address-content {
    padding: 6px 0px;
    color: #333;
    font-size: 13px;

    .line {
      margin-bottom: 6px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .gap {
      margin-left: 30px;
    }
  }

  .cg-btn {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: .1s;
    font-weight: 500;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    padding: 7px 24px;
    font-size: 12px;

    &.red {
      color: #fff;
      background-color: #F81D22;
      border-color: #F81D22;
    }

    &.red-border {
      color: #F81D22;
      background-color: #fff;
      border-color: #F81D22;
    }

    &.mgl-16 {
      margin-left: 16px;
    }

    &:active {
      opacity: 0.8;
    }

    &.big {
      font-size: 14px;
      padding: 12px 30px;
    }
  }

  .cg-dialog-body {
    padding: 24px;

    .line {
      font-size: 14px;
      line-height: 2;
      color: #555;

      .black {
        color: #111;
      }

      .red {
        color: #F81D22;
      }

      &.pdb-20 {
        padding-bottom: 20px;
      }
    }
  }

  .clear-sure-top {
    height: 64px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e6e6e6;
    position: relative;

    .img {
      width: 64px;
      height: 64px;
      float: left;
      border: 1px solid #eee
    }

    .info {
      padding-left: 80px;
    }

    .count {
      position: absolute;
      right: 0;
      bottom: 10px;
      font-size: 12px;
      color: #333;
      line-height: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/detail-order.vue